import indicatorsChart from '../charts/indicators.js';
import spxFedChart from '../charts/indicators/spx-vs-fed.js';
import personalSavingsChart from '../charts/indicators/personal-savings.js';
import ChartPage from '../includes/chart-page.js';

export default async function indicatorsSection(res, section, data, sectionName) {
	const chartPage = new ChartPage();

	await chartPage.init({
		res,
		section,
		data,
		sectionName,
		embedSymbol: sectionName === 'financials' ? `${res.symbol}/${res.ident}` : res.symbol,
		hasRemainingData: sectionName !== 'financials' ? 'IMMEDIATE' : false,
		chartSettings: res.symbol === 'spx-vs-federal-balance' ?
			spxFedChart :
			(
				res.symbol === 'personal-savings' ?
				personalSavingsChart :
				indicatorsChart
			),
		timePeriod: res.timePeriod,
		sliderDefault: res.sliderDefault,
	});
}
